import React from "react";
import { Admin, Resource, ListGuesser, ShowGuesser } from "react-admin";

import polyglotI18nProvider from "ra-i18n-polyglot";
import englishMessages from "./i18n/en";
import customRoutes from "./routes";

import { Layout, Login } from "./layout";
import dataProvider from "./dataProvider";
import authProvider from "./authProvider";
import categories from "./resources/categories";
import cms from "./resources/cms";
import news from "./resources/news";
import recipes from "./resources/recipes";
import videos from "./resources/videos";
import product from "./resources/products";
import products from "./resources/products";
import Dashboard from "./resources/dashboard";
import configs from "./resources/configs";
import Health from "./resources/health";
import banners from "./resources/banners";
import { createBrowserHistory } from "history";

import { PublicRoutes } from "./routes";
import influencers from "./resources/influencers";
import cookings from "./resources/cookings";

const isPublicRoute = (pathname: string) =>
  Object.values(PublicRoutes).some((route) => route === pathname);

const i18nProvider = polyglotI18nProvider((locale) => {
  if (locale === "ar") {
    return import("./i18n/ar").then((messages) => messages.default);
  }

  // Always fallback on english
  return englishMessages;
}, "en");
const history = createBrowserHistory();
const App = () => {
  const { pathname } = window.location;
  if (isPublicRoute(pathname)) {
    return <Health />;
  } else {
    return (
      <Admin
        loginPage={Login}
        layout={Layout}
        history={history}
        dataProvider={dataProvider}
        authProvider={authProvider}
        i18nProvider={i18nProvider}
        dashboard={Dashboard}
        customRoutes={customRoutes}
      >
        {(permissions) => [
          // Only include the categories resource for admin users
          permissions.toLowerCase() === "admin" ? (
            <Resource name="categories" {...categories} />
          ) : null,
          permissions.toLowerCase() === "admin" ? (
            <Resource name="products" {...products} />
            // <Resource name="products" show={ShowGuesser} />
          ) : null,
          // permissions.toLowerCase() === "admin" ? (
          //   <Resource name="cms" {...cms} />
          // ) : null,
          permissions.toLowerCase() === "admin" ? (
            <Resource name="recipes" {...recipes} />
          ) : null,
          permissions.toLowerCase() === "admin" ? (
            <Resource name="influencers" {...influencers} />
          ) : null,
          permissions.toLowerCase() === "admin" ? (
            <Resource name="cookings" {...cookings} />
          ) : null,
          // permissions.toLowerCase() === "admin" ? (
          //   <Resource name="news" {...news} />
          // ) : null,
          // permissions.toLowerCase() === "admin" ? (
          //   <Resource name="config" {...configs} />
          // ) : null,
          permissions.toLowerCase() === "admin" ? (
            <Resource name="banners" {...banners} />
          ) : null,
        ]}
      </Admin>
    );
  }
};

export default App;
